var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6668C4.32634 14.6668 1.33301 11.6735 1.33301 8.00016C1.33301 4.32683 4.32634 1.3335 7.99967 1.3335C11.673 1.3335 14.6663 4.02683 14.6663 7.3335C14.6663 9.54016 12.873 11.3335 10.6663 11.3335H9.48634C9.29967 11.3335 9.15301 11.4802 9.15301 11.6668C9.15301 11.7468 9.18634 11.8202 9.23967 11.8868C9.51301 12.2002 9.66634 12.5935 9.66634 13.0002C9.66634 13.9202 8.91967 14.6668 7.99967 14.6668ZM7.99967 2.66683C5.05967 2.66683 2.66634 5.06016 2.66634 8.00016C2.66634 10.9402 5.05967 13.3335 7.99967 13.3335C8.18634 13.3335 8.33301 13.1868 8.33301 13.0002C8.33301 12.8935 8.27967 12.8135 8.23967 12.7668C7.96634 12.4602 7.81967 12.0668 7.81967 11.6668C7.81967 10.7468 8.56634 10.0002 9.48634 10.0002H10.6663C12.1397 10.0002 13.333 8.80683 13.333 7.3335C13.333 4.76016 10.9397 2.66683 7.99967 2.66683Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 8.6665C4.88529 8.6665 5.33301 8.21879 5.33301 7.6665C5.33301 7.11422 4.88529 6.6665 4.33301 6.6665C3.78072 6.6665 3.33301 7.11422 3.33301 7.6665C3.33301 8.21879 3.78072 8.6665 4.33301 8.6665Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 6C6.88529 6 7.33301 5.55228 7.33301 5C7.33301 4.44772 6.88529 4 6.33301 4C5.78072 4 5.33301 4.44772 5.33301 5C5.33301 5.55228 5.78072 6 6.33301 6Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 6C10.2193 6 10.667 5.55228 10.667 5C10.667 4.44772 10.2193 4 9.66699 4C9.11471 4 8.66699 4.44772 8.66699 5C8.66699 5.55228 9.11471 6 9.66699 6Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 8.6665C12.2193 8.6665 12.667 8.21879 12.667 7.6665C12.667 7.11422 12.2193 6.6665 11.667 6.6665C11.1147 6.6665 10.667 7.11422 10.667 7.6665C10.667 8.21879 11.1147 8.6665 11.667 8.6665Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.3b71f0c07f27ae26f2274ce8b961a032.svg";
export { ForwardRef as ReactComponent };